import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  DASHBOARD_APPROVAL_ACL,
  RNC,
  RNCAPPROVED,
  RNCREJECTED,
  SALES,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../../components/main_comps/custom_date_picker";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";

function BasicDetails({ clientData, isEditClicked, onChange, role, status }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [currentDate, setCurrentDate] = useState(0);
  const [email, setEmail] = useState("");
  const [PAN, setPAN] = useState("");
  const [loading, setLoading] = useState(false);
  const [panValidate, setPanValidate] = useState(false);
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    maxWidth: 500,
    minWidth: 250,
    width: 350,
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };
  const containerStyleDatePicker = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "45px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    border: null,
  };
  const inputStyleDatePicker = {
    color: "black",
    height: "48px",
    borderColor: null,
    border: null,
  };
  const hoveringStyleDatePicker = {
    borderColor: null,
    border: null,
    outline: "none",
  };

  const handleData = () => {
    setFirstName(clientData?.firstName);
    setLastName(clientData?.lastName);
    setMobileNumber(clientData?.mobileNumber);
    setEmail(clientData?.email);
    setDateOfBirth(clientData?.dateOfBirth);
    setPAN(clientData?.panNumber);
  };

  useEffect(() => {
    let date = new Date();
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();

    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    let maxYear = yyyy - 18;
    let max = maxYear + "-" + mm + "-" + dd;
    setCurrentDate(max);
  }, []);

  useEffect(() => {
    onChange({
      firstName: custom_getvalue(firstName, clientData?.firstName),
      lastName: custom_getvalue(lastName, clientData?.lastName),
      email: custom_getvalue(email, clientData?.email),
      mobileNumber: custom_getvalue(mobileNumber, clientData?.mobileNumber),
      dateOfBirth: custom_getvalue(dateOfBirth, clientData?.dateOfBirth),
      PanNumber: custom_getvalue(PAN, clientData?.panNumber),
    });
  }, [firstName, lastName, email, mobileNumber, dateOfBirth, PAN]);
  useEffect(() => {
    handleData();
  }, [isEditClicked, clientData]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "0px 20px",
        }}
      >
        <div style={{ marginTop: 20, width: "50%", minWidth: "300px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>First Name</label>
          <CustomInput
            value={firstName}
            onChange={(data) => {
              if (!isEditClicked) {
                setFirstName(clientData?.firstName);
              } else {
                setFirstName(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="First Name"
            validator="name"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            disabled={isEditClicked ? "" : "disabled"}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "300px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Last Name</label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={lastName}
            onChange={(data) => {
              if (!isEditClicked) {
                setLastName(clientData?.lastName);
              } else {
                setLastName(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Last Name"
            validator="name"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "300px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Mobile Number
          </label>
          <CustomInput
            value={mobileNumber}
            onChange={(data) => {
              if (!isEditClicked) {
                setMobileNumber(clientData?.mobileNumber);
              } else {
                setMobileNumber(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Mobile Number "
            validator="mobile"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            disabled={isEditClicked ? "" : "disabled"}
          />
        </div>

        <div style={{ marginTop: 20, width: "50%", minWidth: "300px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Email</label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={email}
            onChange={(data) => {
              if (!isEditClicked) {
                setEmail(clientData?.email);
              } else {
                setEmail(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Email"
            validator="email"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ marginTop: 20, width: "50%", minWidth: "300px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>DOB </label>
          <CustomDatePicker
            disabled={isEditClicked ? "" : "disabled"}
            value={dateOfBirth}
            onChange={(data) => {
              if (!isEditClicked) {
                setDateOfBirth(clientData?.dateOfBirth);
              } else {
                setDateOfBirth(data);
              }
            }}
            // inputcomponentStyles={{ ...inputStyle }}
            maxDate={currentDate}
            containerStyle={{
              backgroundColor: "white",

              ...containerStyleDatePicker,
            }}
            inputsStyles={{
              padding: "10px",
            }}
            fieldHoverStyles={{ ...hoveringStyleDatePicker }}
            inputStyles={{ ...inputStyleDatePicker }}
            placeholder="Date of birth"
            validator="date"
            type="date"
          />
        </div>

        <div
          style={{
            marginTop: 20,
            width: "50%",
            minWidth: "500px",
            display: "flex",
            gap: 10,
          }}
        >
          <div>
            <label style={{ fontSize: 14, lineHeight: 2 }}>PAN</label>
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              value={PAN}
              onChange={(data) => {
                if (!isEditClicked) {
                  setPAN(clientData?.panNumber);
                } else {
                  setPAN(data);
                }
              }}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="PAN"
              validator="pan"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
          {/* {role === RNC && status !== RNCREJECTED && status !== RNCAPPROVED && (
            <>
              {loading ? (
                <div
                  style={{
                    // marginTop: "5px",
                    // marginLeft: "10px",
                    paddingTop: 40,
                  }}
                >
                  <CustomLoader />
                </div>
              ) : (
                <CustomButton
                  title={panValidate ? "Verified" : "Validate"}
                  onClick={() => {
                    if (!panValidate) {
                      setLoading(!loading);
                      // validateAccountWithPennyDrop({
                      //   accNo: remitterAccountNumber,
                      //   ifsc: remitterAccountIfsc,
                      //   name: remitterAccountName,
                      // });
                    }
                  }}
                  styles={{ alignSelf: "flex-end", marginBottom: "5px" }}
                />
              )}
            </>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default BasicDetails;
